var mp = mp || {};

// Slider - Hero
//-----------------------------------------------------------------
mp.sliderHero = function() {
    var $slider = $('.hero__slider');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        arrows: false,
        dots: false,
        speed: 3000, 
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
        fade: true,
    });
}


// Slider - Lunch
//-----------------------------------------------------------------
mp.sliderLunch = function() {
    var $slider = $('.lunch__slider');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        arrows: false,
        dots: false,
        speed: 1400,
        autoplaySpeed: 1000,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
        fade: true,
    });
}


// Slider - Plans
//-----------------------------------------------------------------
mp.sliderPlans = function() {
    var $slider = $('.floors--single__plans');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        arrows: true,
        dots: false,
        speed: 800,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
    });
}



$(document).ready(function (){
    mp.sliderHero();
    mp.sliderLunch();
});